import { Skeleton } from "../../components/ui/skeleton";

export function TableSkeleton({ columns = 6, rows = 8 }) {
  return (
    <div className="divide-y divide-slate-100">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="grid gap-4 px-5 py-3.5" style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
          {Array.from({ length: columns }).map((__, j) => (
            <Skeleton
              key={j}
              className="h-4"
              style={{ width: `${55 + ((i * 7 + j * 11) % 35)}%` }}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export function StatsSkeleton({ count = 5 }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-white border border-slate-200 rounded-lg p-6">
          <div className="flex items-center justify-between">
            <Skeleton className="h-3 w-20" />
            <Skeleton className="h-7 w-7 rounded-md" />
          </div>
          <Skeleton className="mt-6 h-10 w-16" />
        </div>
      ))}
    </div>
  );
}

export function CardSkeleton({ rows = 4 }) {
  return (
    <div className="bg-white border border-slate-200 rounded-lg">
      <div className="px-6 py-4 border-b border-slate-200">
        <Skeleton className="h-4 w-40" />
        <Skeleton className="mt-2 h-3 w-64" />
      </div>
      <div className="divide-y divide-slate-100">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="px-6 py-3.5 flex items-center gap-6">
            <Skeleton className="h-3 w-48" />
            <Skeleton className="h-3 w-32" />
            <Skeleton className="h-3 w-24 ml-auto" />
          </div>
        ))}
      </div>
    </div>
  );
}
